import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Chip from 'Chip';

/**
 * for this page
 */

import Capital from './capital';
import SecondNav from './secondNav';
import SearchBox from './searchBox';
import LeftCon from './leftCon';
import RightCon from './rightCon';

import { getSituationData, getMarketIsOpen } from '../../../../../services/api';
import {
    formatMrtsData,
    formatRankData,
    formatHygnData,
    formatYdjkData,
    formatZldtData,
    formatLhbData,
} from '../../utils/utils';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        scyl: {
            title: '市场一览',
            current: '0',
            tabTits: [
                {
                    name: '沪深股市',
                    url: 'http://finance.ifeng.com/app/hq/stock/sh000001/',
                },
                {
                    name: '港股',
                    url:
                        'https://finance.ifeng.com/hkSub?iframeUrl=https%3A%2F%2Fifeng.szfiu.com%2Fdynamic.html%23%2Fquotes-center',
                },
                // {
                //     name: '美股',
                //     url: '#',
                // },
                // {
                //     name: '全球指数',
                //     url: '#',
                // },
                // {
                //     name: '外汇',
                //     url: 'http://finance.ifeng.com/forex/',
                // },
            ],
        },
        mrts: {
            title: '每日提示',
            current: 'ipo',
            tabTits: {
                ipo: {
                    name: '新股申购',
                    url: 'http://finance.ifeng.com/newStock/purchase',
                },
                suspend: {
                    name: '停复牌',
                    url: 'http://app.finance.ifeng.com/list/esp.php',
                },
                xsjj: {
                    name: '限售解禁',
                    url: 'http://app.finance.ifeng.com/stock/dxf/',
                },
                mrgg: {
                    name: '每日公告',
                    url: 'http://app.finance.ifeng.com/data/stock/all_gsgg.php',
                },
            },
            tableTits: {
                ipo: [
                    '代码',
                    '证券简称',
                    '申购日期',
                    '发行量?(万股)',
                    '网上发行量?(万股)',
                    '发行价格?(元)',
                    '市盈率',
                    '募集资金?(亿)',
                ],
                suspend: ['代码', '证券简称', '停牌时间', '预计复牌时间', '停牌期限', '停牌原因'],
                xsjj: [
                    '代码',
                    '证券简称',
                    '解禁时间',
                    '流通股数量?(万股)',
                    '本期解禁股份?(万股)',
                    '解禁股份/已流通股份',
                    '解禁市值?(万元)',
                ],
                mrgg: ['公告标题', '证券简称', '公告种类', '公告时间', '更多'],
            },
        },
        rank: {
            title: '沪深两市涨跌榜',
            current: 'ha',
            tabTits: {
                ha: {
                    name: '沪A',
                    url: 'http://app.finance.ifeng.com/list/stock.php?t=ha',
                },
                sa: {
                    name: '深A',
                    url: 'http://app.finance.ifeng.com/list/stock.php?t=sa',
                },
                kcb: {
                    name: '科创板',
                    url: 'http://app.finance.ifeng.com/list/stock.php?t=kcb',
                },
                cyb: {
                    name: '创业板',
                    url: 'http://app.finance.ifeng.com/list/stock.php?t=cyb',
                },
                ah: {
                    name: 'AH',
                    url:
                        'https://finance.ifeng.com/hkSub?iframeUrl=https%3A%2F%2Fifeng.szfiu.com%2Fdynamic.html%23%2Frank%3Fcategory%3Dpremium',
                },
                ggth: {
                    name: '港股通（沪）',
                    url:
                        'https://finance.ifeng.com/hkSub?iframeUrl=https%3A%2F%2Fifeng.szfiu.com%2Fdynamic.html%23%2Frank%3Fcategory%3Dconnect%26market%3DSBSH',
                },
                ggts: {
                    name: '港股通（深）',
                    url:
                        'https://finance.ifeng.com/hkSub?iframeUrl=https%3A%2F%2Fifeng.szfiu.com%2Fdynamic.html%23%2Frank%3Fcategory%3Dconnect%26market%3DSBSZ',
                },
            },
            tableTits: {
                zf: ['涨幅排行', '最新价格', '涨幅'],
                df: ['跌幅排行', '最新价格', '跌幅'],
                vol: ['成交量排行', '最新价格', '成交量(手)'],
                amo: ['成交额排行', '最新价格', '成交额'],
            },
            url: {
                ha: [
                    'http://app.finance.ifeng.com/list/stock.php?t=ha',
                    'http://app.finance.ifeng.com/list/stock.php?t=ha&f=chg_pct&o=asc&p=1',
                    'http://app.finance.ifeng.com/list/stock.php?t=ha&f=volume&o=desc&p=1',
                    'http://app.finance.ifeng.com/list/stock.php?t=ha&f=amount&o=desc&p=1',
                ],
                sa: [
                    'http://app.finance.ifeng.com/list/stock.php?t=sa',
                    'http://app.finance.ifeng.com/list/stock.php?t=sa&f=chg_pct&o=asc&p=1',
                    'http://app.finance.ifeng.com/list/stock.php?t=sa&f=volume&o=desc&p=1',
                    'http://app.finance.ifeng.com/list/stock.php?t=sa&f=amount&o=desc&p=1',
                ],
                kcb: [
                    'http://app.finance.ifeng.com/list/stock.php?t=kcb',
                    'http://app.finance.ifeng.com/list/stock.php?t=kcb&f=chg_pct&o=asc&p=1',
                    'http://app.finance.ifeng.com/list/stock.php?t=kcb&f=volume&o=desc&p=1',
                    'http://app.finance.ifeng.com/list/stock.php?t=kcb&f=amount&o=desc&p=1',
                ],
                zxb: [
                    'http://app.finance.ifeng.com/list/stock.php?t=zxb',
                    'http://app.finance.ifeng.com/list/stock.php?t=zxb&f=chg_pct&o=asc&p=1',
                    'http://app.finance.ifeng.com/list/stock.php?t=zxb&f=volume&o=desc&p=1',
                    'http://app.finance.ifeng.com/list/stock.php?t=zxb&f=amount&o=desc&p=1',
                ],
                cyb: [
                    'http://app.finance.ifeng.com/list/stock.php?t=cyb',
                    'http://app.finance.ifeng.com/list/stock.php?t=cyb&f=chg_pct&o=asc&p=1',
                    'http://app.finance.ifeng.com/list/stock.php?t=cyb&f=volume&o=desc&p=1',
                    'http://app.finance.ifeng.com/list/stock.php?t=cyb&f=amount&o=desc&p=1',
                ],
            },
        },
        hygn: {
            title: '行业概念涨跌榜',
            current: 'hyzf',
            tabTits: {
                hyzf: {
                    name: '行业涨幅榜',
                    url: 'http://app.finance.ifeng.com/list/all_stock_cate.php?s=1',
                },
                hydf: {
                    name: '行业跌幅榜',
                    url: 'http://app.finance.ifeng.com/list/all_stock_cate.php?s=22&f=chg_pct&o=asc',
                },
                gnzf: {
                    name: '概念涨幅榜',
                    url: 'http://app.finance.ifeng.com/list/all_stock_cate.php?s=5',
                },
                gndf: {
                    name: '概念跌幅榜',
                    url: 'http://app.finance.ifeng.com/list/all_stock_cate.php?s=999&f=chg_pct&o=asc',
                },
            },
            tableTits: [['证券简称', '最新价格', '涨幅'], ['证券简称', '最新价格', '跌幅']],
        },
        ydjk: {
            title: '市场异动监控',
            tables: [
                {
                    names: [
                        {
                            name: '市场雷达',
                            url: 'http://app.finance.ifeng.com/hq/stock_scan.php',
                        },
                        {
                            name: '大单追踪',
                            url: 'http://app.finance.ifeng.com/hq/all_stock_bill.php',
                        },
                    ],
                    tits: [['证券简称', '异动类型', '成交价格'], ['证券简称', '成交额', '性质']],
                },
                {
                    names: ['委比排名正', '委比排名负'],
                    tits: [['证券简称', '最新价格', '委比'], ['证券简称', '最新价格', '委比']],
                },
                {
                    names: ['今日振幅排行', '量比排行'],
                    tits: [['证券简称', '最新价格', '振幅'], ['证券简称', '最新价格', '量比']],
                },
                {
                    names: ['成交额排名', '换手率'],
                    tits: [['证券简称', '最新价格', '成交额'], ['证券简称', '最新价格', '换手率']],
                },
            ],
        },
        zldt: {
            title: '主力动态',
            names: {
                zjlrstock: {
                    name: '资金流入',
                    url: 'http://app.finance.ifeng.com/hq/trade/zijin_list.php?level=0&type=z',
                },
                zjlcstock: {
                    name: '资金流出',
                    url: 'http://app.finance.ifeng.com/hq/trade/zijin_list.php?level=0&type=j',
                },
                zjlrhy: {
                    name: '资金流入行业',
                    url: 'http://app.finance.ifeng.com/hq/trade/zijin_cate_list.php?level=0&type=z&cate=ind',
                },
                zjlchy: {
                    name: '资金流出行业',
                    url: 'http://app.finance.ifeng.com/hq/trade/zijin_cate_list.php?level=0&type=j&cate=ind',
                },
            },
            tableTits: {
                zjlrstock: ['证券简称', '金额', '涨跌幅'],
                zjlcstock: ['证券简称', '金额', '涨跌幅'],
                zjlrhy: ['行业名称', '金额', '涨跌幅'],
                zjlchy: ['行业名称', '金额', '涨跌幅'],
            },
            url: {
                zjlrstock: 'http://app.finance.ifeng.com/hq/trade/zijin_list.php?level=0&type=z',
                zjlcstock: 'http://app.finance.ifeng.com/hq/trade/zijin_list.php?level=0&type=j',
                zjlrhy: 'http://app.finance.ifeng.com/hq/trade/zijin_cate_list.php?level=0&type=z&cate=ind',
                zjlchy: 'http://app.finance.ifeng.com/hq/trade/zijin_cate_list.php?level=0&type=j&cate=ind',
            },
        },
        lhb: {
            title: '龙虎榜',
            current: 'sh',
            tabTits: {
                sh: {
                    name: '沪市',
                    url: 'http://lhb.finance.ifeng.com/index.php#sh',
                },
                sz: {
                    name: '深市',
                    url: 'http://lhb.finance.ifeng.com/index.php#sz',
                },
                kcb: {
                    name: '科创板',
                    url: 'http://lhb.finance.ifeng.com/index.php#kcb',
                },
            },
        },
        isOpen: false,
    };

    componentDidMount() {
        this.asyncGetMarketIsOpen();
        setInterval(this.asyncGetMarketIsOpen, 60 * 1000);
        this.asyncGetData();
        setInterval(this.asyncGetData, 60 * 1000);
    }

    asyncGetMarketIsOpen = async () => {
        try {
            if (!this.state.isOpen) {
                const res = await getMarketIsOpen();

                if (res) {
                    const nowtime = new Date(res.nowtime);
                    const today = nowtime.getDate();
                    const _today = new Date().getDate();

                    const target_start = new Date(`${res.nowtime.substring(0, 10)} 09:10`).getTime();
                    const target_end = new Date(`${res.nowtime.substring(0, 10)} 09:27`).getTime();

                    if (
                        Number(res.isopen) === 1 &&
                        today === _today &&
                        nowtime.getTime() > target_start &&
                        nowtime.getTime() < target_end
                    ) {
                        this.setState({
                            isOpen: false,
                        });
                    } else {
                        this.setState({
                            isOpen: true,
                        });
                    }
                }
            }
        } catch (e) {
            console.error(e);
        }
    };

    asyncGetData = async () => {
        try {
            let mrtsData = [];
            let rankData = [];
            let hygnData = [];
            let ydjkData = [];
            let zldtData = [];
            let lhbData = [];

            mrtsData = await getSituationData('stockinfo/mrts');
            if (mrtsData.code === 1 && mrtsData.data) {
                mrtsData = formatMrtsData(mrtsData.data);
            }

            rankData = {
                ha: await getSituationData('stockhq/rank', 'ha'),
                sa: await getSituationData('stockhq/rank', 'sa'),
                kcb: await getSituationData('stockhq/rank', 'kcb'),
                zxb: await getSituationData('stockhq/rank', 'zxb'),
                cyb: await getSituationData('stockhq/rank', 'cyb'),
            };
            if (
                rankData.ha.code === 1 &&
                rankData.ha.data &&
                rankData.sa.code === 1 &&
                rankData.sa.data &&
                rankData.kcb.code === 1 &&
                rankData.kcb.data &&
                rankData.zxb.code === 1 &&
                rankData.zxb.data &&
                rankData.cyb.code === 1 &&
                rankData.cyb.data
            ) {
                rankData = formatRankData(rankData);
            }

            hygnData = await getSituationData('stockinfo/hygn');
            if (hygnData.code === 1 && hygnData.data) {
                hygnData = formatHygnData(hygnData.data);
            }

            ydjkData = await getSituationData('/stockhq/ydjk');
            if (ydjkData.code === 1 && ydjkData.data) {
                ydjkData = formatYdjkData(this.state.ydjk, ydjkData.data);
            }

            zldtData = await getSituationData('stockhq/zldt');
            if (zldtData.code === 1 && zldtData.data) {
                zldtData = formatZldtData(zldtData.data);
            }

            lhbData = await getSituationData('stockhq/lhb');
            if (lhbData.code === 1 && lhbData.data) {
                lhbData = formatLhbData(lhbData.data);
            }

            this.setState({
                ...this.state,
                mrts: {
                    ...this.state.mrts,
                    data: mrtsData,
                },
                rank: {
                    ...this.state.rank,
                    data: rankData,
                },
                hygn: {
                    ...this.state.hygn,
                    data: hygnData,
                },
                ydjk: ydjkData,
                zldt: {
                    ...this.state.zldt,
                    data: zldtData,
                },
                lhb: {
                    ...this.state.lhb,
                    data: lhbData,
                },
            });
        } catch (e) {
            console.error(e);
        }
    };

    render() {
        const { content } = this.props;
        const { mrts, isOpen } = this.state;
        const secondNavData = content.secondNavData;
        const leftCon = content.leftNavData;

        return (
            <div className={styles.content}>
                <Capital />
                <Chip id="170093" type="struct" title="二级导航" groupName="财经行情中心" content={secondNavData}>
                    <SecondNav content={secondNavData} />
                </Chip>
                {mrts.data && <SearchBox content={mrts.data.mrgg} />}
                <div className="clearfix">
                    <LeftCon content={leftCon} />
                    <RightCon content={this.state} isOpen={isOpen} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Content);
